import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface DownloadLoadingProps {
  open: boolean;
}

export default function DownloadLoading({ open }: DownloadLoadingProps) {
  const image = `${
    import.meta.env.VITE_STATIC_ASSETS_URL
  }/img/undraw_Container_ship_ok1c.svg`;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { maxWidth: '500px' },
      }}>
      <Card>
        <CardContent sx={{ pt: 5 }}>
          <Box
            component="img"
            src={image}
            sx={{
              maxHeight: '140px',
              opacity: 0.3,
              width: '100%',
              objectFit: 'contain',
            }}
          />
        </CardContent>

        <DialogTitle>
          <Box sx={{ py: 4 }}>
            <Typography
              variant="h5"
              component="div"
              sx={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={20} thickness={2} sx={{ mr: 1 }} />
              Your download is processing
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h6" sx={{ py: 4, fontWeight: 'normal' }}>
            Please stay on this page until it's finished.
          </Typography>
          <Typography variant="h6" sx={{ py: 4, fontWeight: 'normal' }}>
            For faster download speeds, please only download one report at a
            time.
          </Typography>
        </DialogContent>
      </Card>
    </Dialog>
  );
}
